import React from 'react'
import { Helmet } from 'react-helmet'
import SocialIcons from '../components/SocialIcons'
import QuantumLogo from '../components/QuantumLogo'
import CompanyName from '../components/CompanyName'
import MottoSection from '../components/MottoSection'
import GamePromotion from '../components/GamePromotion'

export default function MainPage() {
    return (
        <>
            <Helmet>
                <title>Alice in Dreamland | Quantum Cat Studios</title>
                <meta name="description" content="Explore 'Alice in Dreamland' — the magical new adventure game by Quantum Cat Studios." />
                <meta name="robots" content="index, follow" />
                <meta name="viewport" content="width=device-width, initial-scale=1" />

                {/* Open Graph Meta Tags */}
                <meta property="og:title" content="Alice in Dreamland | Quantum Cat Studios" />
                <meta property="og:description" content="A whimsical new game from Quantum Cat Studios. Dive into a surreal dream world!" />
                <meta property="og:image" content="https://qcatstudio.com/images/game-logos/alice.png" />
                <meta property="og:url" content="https://qcatstudio.com/" />
                <meta property="og:type" content="website" />

                {/* Twitter Card */}
                <meta name="twitter:card" content="summary_large_image" />

                {/* Structured Data */}
                <script type="application/ld+json">
                    {`
                    {
                        "@context": "https://schema.org",
                        "@type": "VideoGame",
                        "name": "Alice in Dreamland",
                        "author": {
                            "@type": "Organization",
                            "name": "Quantum Cat Studios"
                        },
                        "url": "https://qcatstudio.com/",
                        "image": "https://qcatstudio.com/images/game-logos/alice.png",
                        "description": "A whimsical dream world adventure from Quantum Cat Studios."
                    }
                    `}
                </script>
            </Helmet>

            <main className='main' id='main-content'>
                <section className='container'>
                    <GamePromotion title="Alice in Dreamland" slug="alice" />
                </section>

                <section className='container' style={{ marginTop: '8rem' }}>
                    <h1><CompanyName /></h1>
                    <QuantumLogo />
                </section>

                <section className='container'>
                    <SocialIcons />
                    <MottoSection />
                </section>
            </main>
        </>
    )
}
